<template>
  <div :class="iconClass" :style="{ width: size + 'px', height: size + 'px', marginRight: '0.3rem' }">
    <slot>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.9819 0.640625C17.0783 0.640868 17.9672 1.53051 17.9673 2.62695C17.967 3.72325 17.0782 4.61206 15.9819 4.6123H12.8384L11.1294 6.40918L10.9282 4.6123H7.48877C6.39234 4.61222 5.5027 3.72334 5.50244 2.62695C5.50253 1.53042 6.39224 0.640713 7.48877 0.640625H15.9819Z"
          fill="currentColor"
        />
        <path
          d="M8.59206 3.20533L9.39097 3.68104L9.17961 2.78445L9.8848 2.18183L8.95532 2.10275L8.59206 1.25781L8.2288 2.10275L7.29932 2.18183L8.00451 2.78445L7.79314 3.68104L8.59206 3.20533Z"
          fill="white"
        />
        <path
          d="M12.0165 3.20533L12.8155 3.68104L12.6041 2.78445L13.3093 2.18183L12.3798 2.10275L12.0165 1.25781L11.6533 2.10275L10.7238 2.18183L11.429 2.78445L11.2176 3.68104L12.0165 3.20533Z"
          fill="white"
        />
        <path
          d="M15.4378 3.20533L16.2367 3.68104L16.0253 2.78445L16.7305 2.18183L15.801 2.10275L15.4378 1.25781L15.0745 2.10275L14.145 2.18183L14.8502 2.78445L14.6388 3.68104L15.4378 3.20533Z"
          fill="white"
        />
        <path
          d="M6.42463 6.12133C4.07032 7.70077 5.44367 10.3409 6.42463 11.4635C6.70714 12.021 6.22843 12.3152 5.95376 12.3927C2.56355 12.8572 2.019 14.1512 2.03516 14.8375C2.019 16.8166 4.65889 17.5026 7.83722 17.5026C11.0155 17.5026 13.723 16.9219 13.6053 14.9476C13.4876 12.9734 10.1915 12.6249 9.60295 12.3927C9.13209 12.2069 9.17133 11.6958 9.24981 11.4635C11.0391 8.39754 9.91686 6.62457 9.13209 6.12133C8.19036 5.37807 6.93473 5.81164 6.42463 6.12133Z"
          fill="currentColor"
          stroke="black"
          stroke-width="0.235432"
        />
      </svg>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'IconLead',
    props: {
      iconClass: {
        type: String,
        default: '',
      },

      size: {
        type: [Number, String],
        default: '',
      },
    },
  };
</script>

<style scoped>
  /* You can add any additional styles here */
</style>
